import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { toastSuccess, errorToast } from 'Common/ToastHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { GENERIC_EXPORT_SETUP_FORM_NAME } from 'Common/FormEnum';
import * as constants from 'Common/Constants';
import { DirtyWrapper } from 'Components';
import { Filter, Main } from '../../containers';
import GenericExportSetupForm from './components/GenericExportSetupForm';
import {
  getExportFileType,
  getExportFileField,
  setSaveSuccessful,
  writeGenericExportSetup,
  clearError,
  setExportFileType,
  setExportFileTypeFuture,
} from './state/setup/actions';
import * as Selectors from './state/selectors';

class GenericExportSetupContainer extends Component {
  static propTypes = {
    exportFileTypes: PropTypes.array.isRequired,
    exportFileType: PropTypes.number,
    exportFileTypeFuture: PropTypes.number,
    gridData: PropTypes.array,
    constantValues: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    saveSuccessful: PropTypes.bool.isRequired,
    exportMappingList: PropTypes.object,
    getExportFileType: PropTypes.func.isRequired,
    getExportFileField: PropTypes.func.isRequired,
    setSaveSuccessful: PropTypes.func.isRequired,
    writeGenericExportSetup: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    setExportFileType: PropTypes.func.isRequired,
    setExportFileTypeFuture: PropTypes.func.isRequired,
  };

  static defaultProps = {
    gridData: [],
    exportMappingList: {},
  };

  state = {
    fromOnYesCallback: false,
  };

  componentDidMount() {
    this.props.getExportFileType();
  }

  componentDidUpdate(prevProps) {
    const { saveSuccessful, exportFileType, exportFileTypeFuture } = this.props;
    if (
      prevProps.saveSuccessful !== saveSuccessful &&
      saveSuccessful === true
    ) {
      toastSuccess(constants.SAVED_SUCCESSFULLY);
      this.props.setSaveSuccessful(false);
      this.props.getExportFileField(exportFileType);
    }

    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearError();
    }

    if (prevProps.exportFileType !== exportFileType) {
      this.props.getExportFileField(exportFileType);
    }

    if (
      exportFileType !== exportFileTypeFuture &&
      this.state.fromOnYesCallback
    ) {
      this.props.setExportFileType(exportFileTypeFuture);
      this.setState({ fromOnYesCallback: false });
    }
  }

  formSubmit = values => {
    const model = this.props.gridData.map(x => {
      const found = values.ConstantValues.find(f => f.Id === x.Id);

      return {
        ...x,
        ConstantValue: found.ConstantValue,
        ExportMappingList: !x.Mapped
          ? []
          : Object.keys(values.ExportMappingList).map(key => {
              return {
                ID: 0,
                SourceValue: key,
                MappedValue: values.ExportMappingList[key],
                ExportFileFieldID: x.Id,
              };
            }),
      };
    });

    this.props.writeGenericExportSetup(model);
  };

  getMainProps = () => {
    const { submitting, loading } = this.props;
    return {
      toolbox: {
        formName: GENERIC_EXPORT_SETUP_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: submitting,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  onYesCallback = () => {
    //used in componentDidUpdate control when to change File Type during "dirty"
    this.setState({ fromOnYesCallback: true });
  };

  render() {
    const {
      gridData,
      constantValues,
      exportFileType,
      loading,
      exportMappingList,
    } = this.props;

    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'Generic Export Setup'} />
        <Main {...this.getMainProps()}>
          <DirtyWrapper closeModalYesCallback={this.onYesCallback}>
            {showDirtyConfirm => (
              <GenericExportSetupForm
                exportFileTypes={this.props.exportFileTypes}
                onSubmit={this.formSubmit}
                gridData={gridData}
                initialValues={{
                  ExportFileType: exportFileType,
                  ConstantValues: constantValues,
                  ExportMappingList: exportMappingList,
                }}
                selectedFileType={exportFileType}
                showDirtyConfirm={showDirtyConfirm}
                setExportFileTypeFuture={this.props.setExportFileTypeFuture}
              />
            )}
          </DirtyWrapper>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    exportFileTypes: Selectors.getExportFileTypes(state),
    exportFileType: Selectors.getExportFileType(state),
    exportFileTypeFuture: Selectors.getExportFileTypeFuture(state),
    gridData: Selectors.getGridData(state),
    constantValues: Selectors.getConstantValues(state),
    loading: Selectors.getLoading(state),
    submitting: Selectors.getSubmitting(state),
    saveSuccessful: Selectors.getsaveSuccessful(state),
    exportMappingList: Selectors.getExportMappingList(state),
    error: Selectors.getError(state),
  };
};

const mapDispatchToProps = {
  getExportFileType,
  getExportFileField,
  setSaveSuccessful,
  writeGenericExportSetup,
  clearError,
  setExportFileType,
  setExportFileTypeFuture,
};

export const GenericExportSetup = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GenericExportSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/GenericExportSetup.js